// extracted by mini-css-extract-plugin
module.exports = {"dedicatedSupport":"DedicatedSupport--dedicatedSupport--3Xerx","headerTextBox":"DedicatedSupport--headerTextBox--3HUoq"};